<!-- EM_MO_SB_009  일반충전 -->
<template>
    <div class="stopusing-detail-wrap">
        <div class="stopusing-text-box">
            <strong>사용 중지</strong>
            <span>신청 하시겠습니까?</span>
        </div>
        <div class="stopusing-detail-top">
            <!-- <span class="cake-center shadow"></span> -->
<!--            <img :src=this.prepaidCardImg>-->
            <span class="card-image-border-none" :style="{ backgroundImage:'url('+prepaidCardInfo.imageUrl+')'}"></span>
            <div>
                <em>{{ Number(prepaidCardInfo.remainCash).toLocaleString() }}</em>
                <strong>{{ prepaidCardInfo.prepaidCardNickName}}</strong>
                <span>구매일<small>{{ prepaidCardInfo.issueDate }}</small></span>
            </div>
        </div>
        <div class="fixed" @click="stopUsingEvent()">
            <bottom-button class="button-style" :buttonArray="buttonArray">
            </bottom-button>
        </div>
      <stop-using-popup v-if="stopUsingPopupModal === true" @stopUsingPopup="stopUsingPopupModal = false" :cardInfo="prepaidCardInfo"></stop-using-popup>
    </div>

</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
import StopUsingPopup from "@/views/myemarticon/stopUsingPopup.vue";
import api from "@/api/apiList";


export default {
    name: 'StopUsing',
    components: {StopUsingPopup, BottomButton },
    data() {
        // selectBoardList: <select-board></select-board> 컴포넌트에게 전달할 프롭스
        return {
            stopUsingPopupModal: false,
            buttonArray : [
                {
                    className : "button-bg-yellow",
                    text : "사용 중지 신청",
                    // isDisabled: true,   
                },
            ],
          prepaidCardInfo: {}
        }
    },
    mounted() {
      this.$heading('사용 중지 신청');
      console.log(this.$route.params.cardInfo)
      // 카드상세에서 넘겨받은 파라미터를 Vuex Store에 저장
      if(this.$route.params.cardInfo != null && this.$route.params.cardInfo !== undefined && this.$route.params.cardInfo !== ''){
        this.$store.commit('setPrepaidCardNo', this.$route.params.cardInfo.prepaidCardNo);
      }
      this.getPrepaidCardInfo();  //선불카드 정보 가져오기
    },
    methods: {
    //선불카드 정보 가져오기
    async getPrepaidCardInfo() {
      try {    
        const res = await api.getPrepaidCard(null, { ctmmnyNo: this.$store.state.partnerId, prepaidCardNo: this.$store.state.prepaidCardNo })
        console.log(JSON.stringify("선불카드 가져온 정보:" + res.data.data))
        this.prepaidCardInfo = res.data.data
      } catch (err) {
        console.log(err)
      }
    },
      //사용중지 신청
    async stopUsingEvent(){
      //api 호출
      const params = {
        ctmmnyNo: this.$store.state.partnerId,
        mberNo: this.$store.state.mberInfo.mberNo,
        requestId: this.$store.state.mberInfo.mberNo,
        prepaidCardStatus: "LOCKED",
        methodName: "PUT"
      }
      
      const res = await api.updatePrepaidCardStatus(params, {prepaidCardNo: this.$store.state.prepaidCardNo }).then(res => {
        //const response = res.data;
        //성공시
        if (res.data.code === "S00000") {
          this.stopUsingPopupModal = true
        }
      }).catch(e => {
        console.log(e);
      });
    },
  }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/stopUsing.scss';
</style>